// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export const SDK_VERSION = "1.1.2";
